(function() {
    'use strict';

    var Waypoint = window.Waypoint;

    function createExtension(framework) {
        return function() {
            var waypoints = [];
            var overrides = arguments[0];

            if (framework.isFunction(arguments[0])) {
                overrides = framework.extend({}, arguments[1]);
                overrides.handler = arguments[0]
            }

            this.each(function() {
                var options = framework.extend({}, overrides, {
                    element: this
                });
                if (typeof options.context === 'string') {
                    options.context = framework(this).closest(options.context)[0]
                }
                waypoints.push(new Waypoint(options))
            });

            return waypoints
        }
    }

    if (window.jQuery) {
        window.jQuery.fn.livemeshWaypoint = createExtension(window.jQuery)
    }
    if (window.Zepto) {
        window.Zepto.fn.livemeshWaypoint = createExtension(window.Zepto)
    }
}());


/**
 * Reviews JS
 */
if (typeof (jQuery) != 'undefined') {

    jQuery.noConflict(); // Reverts '$' variable back to other JS libraries

    (function ($) {
        "use strict";

        $(function () {

            var WenpriseFrontend = {

                init: function () {
                    this.setup_animations();
                },

                setup_animations: function () {

                    /* Hide the elements if required to prepare for animation */
                    $(".wprs-visible-on-scroll:not(.animated)").css('opacity', 0);

                    "function" != typeof window.wprs_animate_widgets && (window.wprs_animate_widgets = function () {
                        "undefined" != typeof $.fn.livemeshWaypoint && $(".wprs-animate-on-scroll:not(.animated)").livemeshWaypoint(function () {
                            var animateClass = $(this.element).data("animation");
                            $(this.element).addClass("animated " + animateClass).css('opacity', 1);
                        }, {
                            offset: "85%"
                        })
                    });

                    window.setTimeout(wprs_animate_widgets, 500)
                },

                isMobile: function () {
                    "use strict";
                    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        return true;
                    }
                    return false;
                }
            };


            /* Initialize the common JS for elements */

            WenpriseFrontend.init();

        });

    }(jQuery));

}


(function ($) {

    /**
     * Slick
     *
     * @param $scope
     * @param $
     * @constructor
     */
    var WenpriseWidgetSlickHandler = function ($scope, $) {

        $scope.find('.js-carousel').each(function () {
            $(this).slick();
        });

    };

    /**
     * 状态条动画
     *
     * @param $scope
     * @param $
     * @constructor
     */
    var WenpriseWidgetStatsBarHandler = function ($scope, $) {

        $scope.find('.c-stats-bar__summary').each(function () {

            var dataperc = $(this).data('perc');

            $(this).animate({"width": dataperc + "%"}, dataperc * 20);

        });

    };


    /**
     * 滚动时，显示状态条
     *
     * @param $scope
     * @param $
     * @constructor
     */
    var WenpriseWidgetStatsBarHandlerOnScroll = function ($scope, $) {

        $scope.waypoint(function (direction) {

            WenpriseWidgetStatsBarHandler($(this.element), $);

        }, {
            offset: Waypoint.viewportHeight() - 150,
            triggerOnce: true
        });

    };


    /**
     * 饼图效果
     *
     * @param $scope
     * @param $
     * @constructor
     */
    var WenpriseWidgetPiechartsHandler = function ($scope, $) {

        $scope.find('.js-piechart').each(function () {

            var track_color = $(this).data('track-color');
            var bar_color = $(this).data('bar-color');

            $(this).easyPieChart({
                animate: 2000,
                lineWidth: 10,
                barColor: bar_color,
                trackColor: track_color,
                scaleColor: false,
                lineCap: 'square',
                size: 220

            });

        });

    };


    /**
     * 滚动时，显示饼图效果
     *
     * @param $scope
     * @param $
     * @constructor
     */
    var WenpriseWidgetPiechartsHandlerOnScroll = function ($scope, $) {

        $scope.waypoint(function (direction) {

            WenpriseWidgetPiechartsHandler($(this.element), $);

        }, {
            offset: Waypoint.viewportHeight() - 100,
            triggerOnce: true
        });

    };


    /**
     * 里程计
     *
     * @param $scope
     * @param $
     * @constructor
     */
    var WenpriseWidgetOdometersHandler = function ($scope, $) {

        $scope.find('.c-odometer .c-odometer__number').each(function () {

            var odometer = $(this);

            setTimeout(function () {
                var data_stop = odometer.attr('data-stop');
                $(odometer).text(data_stop);

            }, 100);

        });

    };


    /**
     * 滚动时显示里程计
     *
     * @param $scope
     * @param $
     * @constructor
     */
    var WenpriseWidgetOdometersHandlerOnScroll = function ($scope, $) {

        $scope.waypoint(function (direction) {

            WenpriseWidgetOdometersHandler($(this.element), $);

        }, {
            offset: Waypoint.viewportHeight() - 100,
            triggerOnce: true
        });
    };


    /**
     * 作品集效果
     *
     * @param $scope
     * @param $
     * @constructor
     */
    var WenpriseWidgetPortfolioHandler = function ($scope, $) {

        if ($().isotope === undefined) {
            return;
        }

        var container = $scope.find('.wprs-portfolio');
        if (container.length === 0) {
            return; // no items to filter or load and hence don't continue
        }

        // layout Isotope after all images have loaded
        var htmlContent = $scope.find('.js-isotope');

        var isotopeOptions = htmlContent.data('isotope-options');

        htmlContent.isotope({
            // options
            itemSelector: isotopeOptions['itemSelector'],
            layoutMode: isotopeOptions['layoutMode']
        });

        htmlContent.imagesLoaded(function () {
            htmlContent.isotope('layout');
        });

        /* -------------- Taxonomy Filter --------------- */

        $scope.find('.wprs-taxonomy-filter .wprs-filter-item a').on('click', function (e) {
            e.preventDefault();

            var selector = $(this).attr('data-value');
            container.isotope({filter: selector});
            $(this).closest('.wprs-taxonomy-filter').children().removeClass('wprs-active');
            $(this).closest('.wprs-filter-item').addClass('wprs-active');
            return false;
        });

    };


    /**
     * 挂在到 Elementor 上面
     */
    $(window).on('elementor/frontend/init', function () {

        if (elementorFrontend.isEditMode()) {

            elementorFrontend.hooks.addAction('frontend/element_ready/wprs-slider.default', WenpriseWidgetSlickHandler);

            elementorFrontend.hooks.addAction('frontend/element_ready/wprs-stats-bars.default', WenpriseWidgetStatsBarHandler);

            elementorFrontend.hooks.addAction('frontend/element_ready/wprs-piecharts.default', WenpriseWidgetPiechartsHandler);

            elementorFrontend.hooks.addAction('frontend/element_ready/wprs-odometers.default', WenpriseWidgetOdometersHandler);
        }
        else {

            elementorFrontend.hooks.addAction('frontend/element_ready/wprs-stats-bars.default', WenpriseWidgetStatsBarHandlerOnScroll);

            elementorFrontend.hooks.addAction('frontend/element_ready/wprs-piecharts.default', WenpriseWidgetOdometersHandler);

            elementorFrontend.hooks.addAction('frontend/element_ready/wprs-odometers.default', WenpriseWidgetOdometersHandlerOnScroll);
        }

        elementorFrontend.hooks.addAction('frontend/element_ready/wprs-portfolio.default', WenpriseWidgetPortfolioHandler);

    });

})(jQuery);